import axios from "./axiosInstance";

const PrivacyandPolicyAPI = {
  getPrivacyandPolicy: () => axios.get(`/privacy-policy`),
};

export default PrivacyandPolicyAPI;